<template>
  <div class="product-card-detail flex flex-col md:flex-row">
    <div class="product-card-detail__image relative md:mr-3 mb-2 md:mb-0">
      <VcImage
        :src="product.imgSrc"
        :alt="product.name"
        size-suffix="md"
        class="md:w-[70px] md:h-[70px] md:min-w-[70px] object-contain border p-1 rounded-md"
        lazy
        @click="linkToRoute"
      />
    </div>

    <div class="product-card-detail__content relative flex flex-col justify-between">
      <router-link
        :to="link"
        :title="product.name"
        class="line-clamp-2 w-full text-sm font-bold"
        @click="$emit('link-click', $event)"
      >
        {{ product.name }}
      </router-link>

      <div class="mt-2 flex flex-col">
        <VcItemPrice
          v-if="isAuthenticated"
          :properties="product.properties"
          price-color-class="!text-[--body-text-color]"
          class="mb-2 text-sm !flex-row space-x-2"
          :value="product.price"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { getProductRoute } from "@/core/utilities";
import { useUser } from "@/shared/account";
import type { Product } from "@/core/api/graphql/types";
import type { PropType } from "vue";
import type { RouteLocationRaw } from "vue-router";

defineEmits<{ (eventName: "link-click", globalEvent: PointerEvent): void }>();

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
});

const { isAuthenticated } = useUser();

const link = computed<RouteLocationRaw>(() => getProductRoute(props.product.id, props.product.slug));
const router = useRouter();

function linkToRoute() {
  router.push(link.value);
}
</script>
